import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, Input, Row, Label, Modal, ModalBody, ModalHeader, Button, ModalFooter } from "reactstrap";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import { NotificationManager } from "../../../../../../components/common/react-notifications";
import { gAPI_Group_By_Id, gAPI_Site_Settings, postAPI_Site_Settings as putAPI_Site_Settings } from "../../../../../../constants/APIs";
import { AxiosAPI } from "../../../../../../helpers/AxiosAPI";
import ImageGallery from '../../../propinfo/gallery/index';
import { themeColorStorageKey } from "../../../../../../constants/defaultValues";
import no_image from '../../../../../../assets/no_image.png';

const lightThemeColors = ['light.purple', 'light.blue', 'light.green', 'light.orange', 'light.red'];
const darkThemeColors = ['dark.purple', 'dark.blue', 'dark.green', 'dark.orange', 'dark.red'];

export default function ServiceProviderForm({ data, isVisible, toggle, loadList }) {
    const [serviceProviderData, setServiceProviderData] = useState(data || {
        poweredByLogo: '',
        poweredByLogoBot: '',
        logo: '',
        territory: '',
        senderAddress: '',
        comments: '',
        senderName: '',
        connectWarekey: '',
        senderZip: '',
        senderCity: '',
        fromName: '',
        from: '',
        id: 0,
        colorTheme: '',
        poweredByUrl: '',
        disableChannels: [],
        disableApplications: [],
        helpCenterUrl: '',
        featuresUrl: '',
        isShowChat: false,
        dashboardUrl: ''
    });
    // console.log('col', serviceProviderData.colorTheme)
    const [isLogoSelected, setIsLogoSelected] = useState(false);
    const [isBotLogoSelected, setIsBotLogoSelected] = useState(false);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [selectedColorTheme, setSelectedColorTheme] = useState(serviceProviderData.colorTheme || '');

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        if (name === "disableChannels" || name === "disableApplications") {
            setServiceProviderData({
                ...serviceProviderData,
                [name]: value ? value.split(",").map(item => item.trim()) : [],
            });
        } else {
            setServiceProviderData({
                ...serviceProviderData,
                [name]: value,
            });
        }
        console.log('service', serviceProviderData)
    };

    const selectedImage = (image) => {
        if (isLogoSelected) {
            setServiceProviderData({ ...serviceProviderData, logo: image.src });
        } else if (isBotLogoSelected) {
            setServiceProviderData({ ...serviceProviderData, poweredByLogoBot: image.src });
        } else {
            setServiceProviderData({ ...serviceProviderData, poweredByLogo: image.src });
        }
    };

    const handleLogo = () => {
        setIsLogoSelected(true);
        togglegallery();
    };

    const handleColorThemeChange = (color) => {
        setServiceProviderData(prevState => ({
            ...prevState,
            colorTheme: color
        }));
    };
    // console.log('295', selectedColorTheme, serviceProviderData, typeof serviceProviderData.disableChannels)
    const handleSave = () => {
        // console.log('datatosave', serviceProviderData);

        const dataToSave = {
            ...serviceProviderData,
        }

        AxiosAPI({
            method: 'put',
            url: `${putAPI_Site_Settings}`,
            data: dataToSave,
        })
            .then(res => {
                loadList();
                toggle();
                NotificationManager.success(
                    "",
                    "Profile updated successfully",
                    3000,
                    null,
                    null,
                    "success"
                );
                setTimeout(function () {
                    window.location.reload();
                }, 1000);
            });
    };


    const handlePoweredByLogo = () => {
        setIsLogoSelected(false);
        togglegallery();
    };

    const handlePoweredByLogoBot = () => {
        setIsBotLogoSelected(true);
        togglegallery();
    };
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={''}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    return (
        <Fragment>
            <Modal
                isOpen={isVisible}
                toggle={toggle}
                style={{ maxWidth: '1000px' }}
            >
                <ModalHeader toggle={toggle}>
                    Service Provider
                </ModalHeader>
                <ModalBody>
                    <Colxx md={12}>
                        <Row className="mb-4">
                            <Colxx xxs="12">
                                <Row>
                                    <Colxx sm={6} className="mb-3">
                                        <Label>Name</Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.senderName}
                                            onChange={handleChange}
                                            name="senderName"
                                        />
                                    </Colxx>
                                    <Colxx sm={6} className="mb-3">
                                        <Label>Address</Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.senderAddress}
                                            onChange={handleChange}
                                            name="senderAddress"
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-3">
                                        <Label>ConnectWare Key</Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.connectWarekey}
                                            onChange={handleChange}
                                            name="connectWarekey"
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-3">
                                        <Label>Territory</Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.territory}
                                            onChange={handleChange}
                                            name="territory"
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-3">
                                        <Label>Email </Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.from}
                                            onChange={handleChange}
                                            name="from"
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-3">
                                        <Label>From Name</Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.fromName}
                                            onChange={handleChange}
                                            name="fromName"
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-3">
                                        <Label>City </Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.senderCity}
                                            onChange={handleChange}
                                            name="senderCity"
                                        />
                                    </Colxx>
                                    <Colxx sm={3} className="mb-3">
                                        <Label>ZipCode</Label>
                                        <Input
                                            type="text"
                                            value={serviceProviderData.senderZip}
                                            onChange={handleChange}
                                            name="senderZip"
                                        />
                                    </Colxx>
                                </Row>
                            </Colxx>

                            {/* 
                            <Colxx sm={12}>
                                <Row> */}
                            <Colxx sm={12} className="mb-3">
                                <h3>Theme Color</h3>

                                <Label>Light Theme Color</Label><br />
                                <div className="d-flex flex-wrap">

                                    {lightThemeColors.map((theme) => (
                                        <div
                                            key={theme}
                                            onClick={() => handleColorThemeChange(theme)}
                                            className={`theme-color ${serviceProviderData.colorTheme === theme ? 'active' : ''}`}
                                            style={{
                                                backgroundColor: theme === 'light.purple' ? '#Ef4A81' :
                                                    theme === 'light.blue' ? '#145388' :
                                                        theme === 'light.green' ? '#576a3d' :
                                                            theme === 'light.orange' ? '#e2863b' : '#3399cc',
                                                width: serviceProviderData.colorTheme === theme ? '45px' : '40px',
                                                height: serviceProviderData.colorTheme === theme ? '45px' : '40px',
                                                margin: '20px',
                                                cursor: 'pointer',
                                                border: serviceProviderData.colorTheme === theme ? '3px solid var(--primary-color)' : 'none',
                                                borderRadius: '50%',
                                                transition: 'width 0.3s, border 0.3s'
                                            }}
                                        />
                                    ))}
                                </div>
                                <Label>Dark Theme Color</Label><br />
                                <div className="d-flex flex-wrap">
                                    {darkThemeColors.map((theme) => (
                                        <div
                                            key={theme}
                                            onClick={() => handleColorThemeChange(theme)}
                                            className={`theme-color ${serviceProviderData.colorTheme === theme ? 'active' : ''}`}
                                            style={{
                                                backgroundColor: theme === 'dark.purple' ? '#86367e' :
                                                    theme === 'dark.blue' ? '#1a3a53' :
                                                        theme === 'dark.green' ? '#3e6804' :
                                                            theme === 'dark.orange' ? '#b15204' : '#3399cc',
                                                width: serviceProviderData.colorTheme === theme ? '45px' : '40px',
                                                height: serviceProviderData.colorTheme === theme ? '45px' : '40px',
                                                margin: '20px',
                                                cursor: 'pointer',
                                                border: serviceProviderData.colorTheme === theme ? '3px solid var(--primary-color)' : 'none',
                                                borderRadius: '50%',
                                                transition: 'width 0.3s, border 0.3s'

                                            }}
                                        />
                                    ))}
                                </div>
                            </Colxx>
                            {/* </Row>
                            </Colxx> */}

                            <Fragment>
                                <Colxx sm={12}>
                                    <h4>Logo</h4>
                                </Colxx>
                                <Colxx sm={12}>
                                    <Row>
                                        <Colxx sm={3} className="md-3">
                                            <img
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain'
                                                }}
                                                src={
                                                    serviceProviderData.logo || no_image
                                                }
                                            />
                                        </Colxx>
                                        <Colxx sm={3} className="mb-3">
                                            <Label>Browse</Label>
                                            <div
                                                className="iconsminds-photo"
                                                onClick={(event) => handleLogo()}
                                                style={{
                                                    cursor: 'pointer',
                                                    fontSize: '28px',
                                                    color: '#73236b',
                                                }}
                                            ></div>
                                        </Colxx>
                                    </Row>
                                </Colxx>

                            </Fragment>
                            <Fragment>
                                <Colxx sm={6}>
                                    <Row>
                                        <Colxx sm={12}>
                                            <h4>Powered By Logo</h4>
                                        </Colxx>
                                        <Colxx sm={12}>
                                            <Row>
                                                <Colxx sm={6} className="md-3">
                                                    <img
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                        alt="room image"
                                                        src={
                                                            serviceProviderData.poweredByLogo || no_image
                                                        }
                                                    />
                                                </Colxx>
                                                <Colxx sm={6} className="mb-3">
                                                    <Label>Browse</Label>
                                                    <div
                                                        className="iconsminds-photo"
                                                        onClick={(event) => handlePoweredByLogo()}
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontSize: '28px',
                                                            color: '#73236b',
                                                        }}
                                                    ></div>
                                                </Colxx>
                                            </Row>
                                        </Colxx>
                                    </Row>
                                </Colxx>
                                <Colxx sm={6}>
                                    <Row>
                                        <Colxx sm={12}>
                                            <h4>Powered By Logo Bot</h4>
                                        </Colxx>
                                        <Colxx sm={12}>
                                            <Row>
                                                <Colxx sm={6} className="md-3">
                                                    <img
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                        alt="room image"
                                                        src={
                                                            serviceProviderData.poweredByLogoBot || no_image
                                                        }
                                                    />
                                                </Colxx>
                                                <Colxx sm={6} className="mb-3">
                                                    <Label>Browse</Label>
                                                    <div
                                                        className="iconsminds-photo"
                                                        onClick={(event) => handlePoweredByLogoBot()}
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontSize: '28px',
                                                            color: '#73236b',
                                                        }}
                                                    ></div>
                                                </Colxx>
                                            </Row>
                                        </Colxx>
                                    </Row>

                                </Colxx>
                                <Colxx sm={12} className="mb-3">
                                    <Label>Powered By Logo Url</Label>
                                    <Input
                                        type="text"
                                        value={serviceProviderData.poweredByUrl}
                                        onChange={handleChange}
                                        name="poweredByUrl"
                                    />
                                </Colxx>
                            </Fragment>
                            <Colxx sm={12} className="mb-3">
                                <Label>Disable Channels</Label>
                                <Input
                                    type="text"
                                    value={Array.isArray(serviceProviderData.disableChannels) ? serviceProviderData.disableChannels.join(", ") : ''}
                                    onChange={handleChange}
                                    name="disableChannels"
                                />
                            </Colxx>
                            <Colxx sm={12} className="mb-3">
                                <Label>Disable Applications</Label>
                                <Input
                                    type="text"
                                    value={Array.isArray(serviceProviderData.disableApplications) ? serviceProviderData.disableApplications.join(", ") : ''}
                                    onChange={handleChange}
                                    name="disableApplications"
                                />
                            </Colxx>
                            <Colxx sm={12} className="mb-3">
                                <Label>Dashboard Url</Label>
                                <Input
                                    type="text"
                                    value={serviceProviderData.dashboardUrl}
                                    onChange={handleChange}
                                    name="dashboardUrl"
                                />
                            </Colxx>
                            <Colxx sm={12} className="mb-3">
                                <Label>Help Center Url</Label>
                                <Input
                                    type="text"
                                    value={serviceProviderData.helpCenterUrl
                                    }
                                    onChange={handleChange}
                                    name="helpcenterUrl"
                                />
                            </Colxx>
                            <Colxx sm={12} className="mb-3">
                                <Label>Feature Updates Url</Label>
                                <Input
                                    type="text"
                                    value={serviceProviderData.featuresUrl}
                                    onChange={handleChange}
                                    name="featuresUrl"
                                />
                            </Colxx>
                            <Colxx sm={12} className="mb-3">
                                <Label>Show Support Chat Widget</Label>
                                <div>
                                    <Label className="mr-3 ml-5">
                                        <Input
                                            type="radio"
                                            name="isShowChat"
                                            value={true}
                                            checked={serviceProviderData.isShowChat === true}
                                            onChange={() => handleChange({ target: { name: 'isShowChat', value: true } })}
                                        />
                                        Yes
                                    </Label>
                                    <Label className="ml-3">
                                        <Input
                                            type="radio"
                                            name="isShowChat"
                                            value={false}
                                            checked={serviceProviderData.isShowChat === false}
                                            onChange={() => handleChange({ target: { name: 'isShowChat', value: false } })}
                                        />
                                        No
                                    </Label>
                                </div>
                            </Colxx>
                            <Colxx sm={12} className="mb-3">
                                <Label>Comments</Label>
                                <Input
                                    type="textarea"
                                    value={serviceProviderData.comments}
                                    onChange={handleChange}
                                    name="comments"
                                />
                            </Colxx>

                        </Row>
                        {ImageGalleryButton()}
                    </Colxx>
                </ModalBody>
                <ModalFooter>
                    <Colxx sm={12} className="mb-3 text-right">
                        <Button color="primary" onClick={handleSave}>
                            Save
                        </Button>
                        <Button color="secondary" className="ml-2" onClick={toggle}>
                            Close
                        </Button>
                    </Colxx>
                </ModalFooter>
            </Modal >
        </Fragment >
    );
}